import { InvoiceState } from '@/services/ws-invoices/src/main/resources/rest-api';
import type { IdentityRole } from '@/js/libs/use-auth';
import { Roles } from '@/js/libs/use-auth';

/** The states the page lists invoices of, in the order the state filter offers them (V1's tabs). */
export const INVOICES_STATES = [
  InvoiceState.ALL,
  InvoiceState.OPEN,
  InvoiceState.CHARGED,
  InvoiceState.CANCELED,
  InvoiceState.PAID,
  InvoiceState.FIRST_REMINDER,
  InvoiceState.SECOND_REMINDER,
  InvoiceState.THIRD_REMINDER,
  InvoiceState.PERSONAL_CALL_REMINDER,
  InvoiceState.PERSONAL_CALL_REQUESTED_REMINDER,
  InvoiceState.COLLECTION_REMINDER,
  InvoiceState.BAD_DEBT,
  InvoiceState.MANUAL_ARCHIVED,
  InvoiceState.AUTO_ARCHIVED,
] as const satisfies readonly InvoiceState[];

export type InvoicesState = (typeof INVOICES_STATES)[number];

/** The permission whose companies the company filter lists. The context counts them to tell whether the filter shows. */
export const COMPANY_FILTER_PERMISSIONS: IdentityRole[] = [Roles.ADMIN_INVOICE];

/** States in which an invoice has been sent and counts the days since. */
export const DAYS_SINCE_INVOICING_STATES: readonly InvoiceState[] = [
  InvoiceState.CHARGED,
  InvoiceState.FIRST_REMINDER,
  InvoiceState.SECOND_REMINDER,
  InvoiceState.THIRD_REMINDER,
  InvoiceState.COLLECTION_REMINDER,
  InvoiceState.PERSONAL_CALL_REMINDER,
  InvoiceState.PERSONAL_CALL_REQUESTED_REMINDER,
];

/**
 * States of an invoice not billed yet, which is checked for the invoice info its bill will need: the one of its company,
 * sales unit and currency. V1 checked the same states.
 */
export const INVOICE_INFO_STATES: readonly InvoiceState[] = [InvoiceState.OPEN, InvoiceState.MANUAL_ARCHIVED, InvoiceState.AUTO_ARCHIVED];

/** States in which the backend schedules a next reminder for an invoice. */
export const NEXT_REMINDER_STATES: readonly InvoiceState[] = [
  InvoiceState.CHARGED,
  InvoiceState.FIRST_REMINDER,
  InvoiceState.SECOND_REMINDER,
  InvoiceState.THIRD_REMINDER,
  InvoiceState.PERSONAL_CALL_REQUESTED_REMINDER,
];
